module.exports = __webpack_public_path__ + "img/player-pause.ebf7ca34.svg";